<template>
  <drag tag="tr" class="table-item" :transfer-data="rsvp" :draggable="!inMap"
        @dragstart="$store.commit('laxit/setDropzoneShow', true)"
        @dragend="$store.commit('laxit/setDropzoneShow', false)" v-if="!isMobile">
    <div slot="image" class="dragslot">Reservation {{ rsvp.id }}</div>
    <td class="map-button un-map" @click="toggleInMap">
      <a href="javascript:;"
         v-bind:class="{ selected: inMap }">
        <i class="fas fa-map-marker-alt"></i>
      </a>
    </td>
    <td class="un-id">
      <a href="javascript:;" :href="'/#/reservation/' + rsvp.id" target="_blank" >{{ rsvp.id }}</a>
    </td>
    <td>
      <div v-bind:class="'status ' + rsvp.statusClass">{{ rsvp.status }}</div>
      <span v-if="acceptedRTGStatus(rsvp.status) && rsvp.pickup.geofenceType === 'airport'" class="rtg" @click="showRTG(rsvp.id)">RTG</span>
    </td>
    <td class="un-pickup-time"><span>{{ rsvp.pickupTime }}</span></td>
    <td>{{ getAddress(rsvp.dropoff) }}</td>
    <!-- <td class="un-pickup"><span>{{ getAddress(rsvp.pickup) }}</span></td> -->
    <!-- <td class="un-dropoff"><span>{{ getAddress(rsvp.dropoff) }}</span></td> -->
    <!-- <td class="sector-data">
      <ul v-if="rsvp.pickupSectors !== null && rsvp.pickupSectors.length > 0">
        <li v-for="sector in rsvp.pickupSectors">
          {{ sector.name }}
        </li>
      </ul>
      <span v-else>N/A</span>
    </td>
    <td class="sector-data">
      <ul v-if="rsvp.dropoffSectors !== null && rsvp.dropoffSectors.length > 0">
        <li v-for="sector in rsvp.dropoffSectors">
          {{ sector.name }}
        </li>
      </ul>
      <span v-else>N/A</span>
    </td> -->
    <!-- <td class="un-btt"><span>{{ rsvp.beThereTime }}</span></td> -->
    <!-- <td>
      <a href="javascript:;" :href="'/#/consumer/' + rsvp.customer.id" target="_blank">{{ rsvp.customer.firstName }} {{ rsvp.customer.lastName }}</a><br/>
      <a href="javascript:;" v-if="rsvp.customer.phone !== null" @click="callPhone(rsvp.customer)">{{ rsvp.customer.phone }}</a>
    </td>-->
    <td class="image">
      <span v-if="rsvp.flight !== null">
        <a href="javascript:;" @click="showFlightInfo">
          <span>{{ rsvp.flight.airline }}</span>
          <span>{{ rsvp.flight.flightNumber }}</span>
        </a>
        <span v-if="flightStatus !== null" v-bind:class="'flight-status ' + flightStatus.class">{{ flightStatus.label }}</span>
      </span>
      <span v-else>N/A</span>
    </td>
    <!-- <td class="flight-column un-flight">
      <div class="flight-box">
        <div class="flight-img">
          <img src="/assets/img/arrival.png" v-if="rsvp.pickup.geofenceType === 'airport'" />
          <img src="/assets/img/departure.png" v-if="rsvp.dropoff.geofenceType === 'airport'" />
        </div>
        <div class="flight-info">
          <span v-if="rsvp.flight.airlineCode === null">N/A</span>
          <a href="javascript:;" v-else @click="showFlightInfo">
            {{ rsvp.flight.airline }} {{ rsvp.flight.flightNumber}}
          </a><br/>
          <span v-if="rsvp.flight.airlineCode !== null && flightStatus !== null" v-bind:class="'flight-status ' + flightStatus.class">{{ flightStatus.label }}</span>
        </div>
      </div>
    </td> -->
    <td class="un-ada">
      <div v-if="rsvp.ada === null || (!rsvp.ada.wheelchair && !rsvp.ada.serviceDog)">N/A</div>
      <div v-else>
        <span v-show="rsvp.ada.serviceDog"><svg-dog></svg-dog></span>
        <span v-show="rsvp.ada.wheelchair"><svg-wheelchair></svg-wheelchair></span>
      </div>
    </td>
    <td class="un-pax">{{ rsvp.passengers }}</td>
    <td class="un-luggage">{{ rsvp.luggage }}</td>
  </drag>
  <div v-else class="table-card">
    <div class="row-1">
      <div>
        <a href="javascript:;" :href="'/#/reservation/' + rsvp.id" target="_blank" >{{ rsvp.id }}</a>
        <div v-bind:class="'status ' + rsvp.statusClass">{{ rsvp.status }}</div>
        <span v-if="acceptedRTGStatus(rsvp.status) && rsvp.pickup.geofenceType === 'airport'" class="rtg" @click="showRTG(rsvp.id)">RTG</span>
      </div>
      <div class="map-button"  @click="toggleInMap">
        <a href="javascript:;"
         v-bind:class="{ selected: inMap }">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </div>
    </div>
    <div>
      <div>Pickup Time: {{ rsvp.pickupTime }}</div>
    </div>

    <div>
      <div>Dropoff: {{ getAddress(rsvp.dropoff) }}</div>
    </div>

    <div class="image">
      <span v-if="rsvp.flight !== null">
        <a href="javascript:;" @click="showFlightInfo">
          <span>{{ rsvp.flight.airline }}</span>
          <span>{{ rsvp.flight.flightNumber }}</span>
        </a>
        <span v-if="flightStatus !== null" v-bind:class="'flight-status ' + flightStatus.class">{{ flightStatus.label }}</span>
      </span>
      <span v-else>N/A</span>
    </div>

    <div class="toggle-div">
      <div class="row-7">
        <div>
          <span><i class="fas fa-user-friends icon"></i>{{ rsvp.passengers }}</span>
          <span><i class="fas fa-suitcase icon"></i>{{ rsvp.luggage }}</span>
          <span><strong>ADA:</strong>
            <span v-if="rsvp.ada === null || (!rsvp.ada.wheelchair && !rsvp.ada.serviceDog)">N/A</span>
            <span v-else>
              <span v-show="rsvp.ada.serviceDog"><svg-dog></svg-dog></span>
              <span v-show="rsvp.ada.wheelchair"><svg-wheelchair></svg-wheelchair></span>
            </span>
            </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiFlightInfo from '@/modules/api/flight-info'

import SvgDog from '@/components/Partials/SVG/ServiceDog'
import SvgWheelchair from '@/components/Partials/SVG/Wheelchair'
export default {
  name: 'reservation-row',
  props: ['rsvp', 'isMobile'],
  components: { SvgDog, SvgWheelchair },
  data () {
    return {
      flightStatus: null
    }
  },
  computed: {
    inMap () {
      let self = this
      let mapItems = self.$store.state.laxit.dropzone.items
      let item = mapItems.filter(mapItem =>
        mapItem.reservationID === self.rsvp.id && mapItem.packageID === null)
      return item.length > 0
    },
    checkedReservations: {
      get () { return this.$store.state.laxit.unroutedReservations.checked },
      set (value) {
        this.$store.commit('laxit/setTncReservationsChecked', [])
        this.$store.commit('laxit/setUnroutedReservationsChecked', value)
      }
    }
  },
  methods: {
    getAddress (location) {
      if (location.geofenceType === 'airport' &&
          location.geofenceName !== '') {
        let result = location.geofenceName
        if (location.terminal && location.terminal !== '' && location.terminal !== 'undefined') {
          result += ' - Terminal ' + location.terminal
        }
        return result
      }
      return location.title

      // let address = ''
      // if (location.city) {
      //   address = address + location.city + ' '
      // }
      // if (location.zip) {
      //   address = address + location.zip
      // }

      // return address
    },
    showFlightInfo () {
      let self = this
      ApiFlightInfo.loadFlightInfo(self, self.rsvp, r => {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' }
          return
        }
        self.flightStatus = self.translateFlightStatus(r.status)
      })
    },
    getFlightStatus () {
      let self = this
      if (self.rsvp.airlineCode === null ||
          self.rsvp.statusClass === 'complete' ||
          self.rsvp.statusClass === 'completed' ||
          self.rsvp.statusClass === 'canceled') {
        self.flightStatus = null
        return
      }
      let date = moment(self.rsvp.pickupTime, 'MM/DD/YYYY hh:mm A')
      let airlineDate = encodeURIComponent(date.format('YYYY-MM-DD'))
      let airlineTime = encodeURIComponent(date.format('HH:mm:ss'))
      let flightNumber = self.rsvp.flightNumber || self.rsvp.dropoffFlightNumber
      let isDeparture = '&departure=0'
      if ((self.rsvp.airline === null || self.rsvp.airline === '') &&
        (self.rsvp.dropoffAirline !== null && self.rsvp.dropoffAirline !== '')
      ) {
        isDeparture = '&departure=1'
      }
      let url = '/availability/flights/' +
                  self.rsvp.airlineCode + flightNumber +
                  '?date=' + airlineDate +
                  '&time=' + airlineTime +
                  '&airport=' + self.rsvp.airportCode +
                  isDeparture
      self.$sdk.get(url, {}, r => {
        if (r.error) {
          self.flightStatus = { label: 'On Time', class: 'ontime' }
          return
        }
        self.flightStatus = self.translateFlightStatus(r.status)
      })
    },
    translateFlightStatus (status) {
      switch (status) {
        case 'Scheduled': return { label: 'On Time', class: 'ontime' }
        case 'Proposed': return { label: 'On Time', class: 'ontime' }
        case 'OutGate': return { label: 'On Time', class: 'ontime' }
        case 'InAir': return { label: 'On Air', class: 'onair' }
        case 'Landed': return { label: 'Arrived', class: 'arrived' }
        case 'InGate': return { label: 'Arrived', class: 'arrived' }
        case 'Expected': return { label: 'On Time', class: 'ontime' }
        case 'NoTakeOffInfo': return { label: 'On Time', class: 'ontime' }
        case 'Delayed': return { label: 'Delayed', class: 'delayed' }
        case 'Cancelled': return { label: 'Cancelled', class: 'cancelled' }
        case 'Unknown': return { label: 'On Time', class: 'ontime' }
        case 'PastFlight': return { label: 'Arrived', class: 'arrived' }
        case 'Original' : return { label: 'On Time', class: 'ontime' }
      }
      return { label: 'On Time', class: 'ontime' }
    },
    toggleInMap () {
      let self = this
      if (self.inMap) {
        self.$store.commit('laxit/removeDropzoneItems', self.rsvp)
        return
      }
      self.removeMapOnlyItems()
      self.$store.commit('laxit/addDropzoneItem', self.rsvp)
    },
    callPhone (info) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: info.phone,
        name: info.firstName + ' ' + info.lastName
      })
    },
    showRTG (id) {
      this.$store.commit('laxit/setReadyToGoID', id)
      this.$store.commit('laxit/setReadyToGoShow', true)
      this.$store.commit('laxit/setReadyToGoSuccess', false)
      this.$store.commit('laxit/setReadyToGoTable', 'unrouted')
    },
    acceptedRTGStatus (status) { return ['UPCOMING', 'REQUIRES DISPATCH', 'DISPATCHED'].indexOf(status) > -1 },
    removeMapOnlyItems () {
      if (this.$store.state.laxit.tncReservations.viewingInMap) {
        this.$store.commit('laxit/clearDropzone')
        this.$store.commit('laxit/setViewingInMap', false)
      }
    }
  },
  watch: {
    rsvp (value) {
      // this.getFlightStatus()
    }
  },
  mounted () {
    // let self = this
    // self.getFlightStatus()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
.dragslot {
  font-weight: 700;
  background-color: #fff;
  padding: 5px;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
  border: 1px solid rgba(0,0,0,0.4);
  border-radius: 3px;
}
.table-item {
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  position: relative;

  & input[type="checkbox"]{
    margin-top: 0;
    width: auto;
  }

  & td{
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    & a{ font-weight: 700; }

    &.map-button{
      padding: 10px;

      & a{
        color: #fff;
        background-color: #aaa;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        display: inline-block;
        border-radius: 30px;
        transition: all 250ms;

        & i {line-height: inherit;}

        &.disabled{
          pointer-events: none;
          opacity: 0.5;
          background-color: #bbb;
        }
        &.selected{
          background-color: #26D97A;
        }
      }
    }

    &.flight-column{ width: 130px; }
    .flight-img{
      width: 30px;
      display: inline-block;
      vertical-align: top;
    }
    .flight-info{
      width: 70px;
      display: inline-block;
    }
    & .flight-status{ padding: 1px 4px; font-size: 10px; }

    &.pool-yes { color: #26D97A; }
    &.pool-no { color: #F20D0D; }

    &.un-check{ width: 24px!important; }
    &.un-id a{
      width: 50px!important;
      display: block;
    }
    &.un-luggage{ width: 70px!important; }
    &.un-pickup-time span, &.un-btt span{
      width: 65px!important;
      display: block;
    }
    &.un-pickup span, &.un-dropoff span{
      width: 211px!important;
      display: block;
    }
    &.un-flight .flight-box{
      width: 118px!important;
      display: block;
    }
    &.un-ada{ width: 50px!important; }
    &.un-pax{ width: 38px!important; }
    &.un-map{ width: 40px!important; }
  }

  & .sector-data {
    & ul {
      text-align: left;
      margin: 0;
      padding-left: 15px;
    }
  }
}

.rtg{
  color: #fff;
  line-height:1;
  display:block;
  font-size:12px;
  font-weight: 600;
  margin: 2px 4px;
  cursor: pointer;
  padding: 3px 10px;
  border-radius: 4px;
  background: #2586f3;
  letter-spacing: 1px;
  border-bottom: 3px solid #084991;
}

.image img {
  width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/UnroutedReservationsRow.vue